import React from "react";

const selfRegTOPDateComponent = replaceText => (
  <>
    <span>
      <strong>Great News! We have completed reviewing your registration paperwork packet and everything looks great!</strong>          
    </span>
    <p>Here are your next steps:</p>
    <ul>
      <li>Your registration paperwork is in the mail and should arrive to your home address on file in 5-10 business days</li>
      <ul>
        <li>Our packet will include a cover letter that will breakdown each document needed for your specific location and how you can move forward to complete the Registration.</li>
      </ul>
      <li>Review the cover letter in the delivery packet and collect any documents that may need to be provided on your end! (Don&apos;t forget your Identification)</li>
      <li>Find a local DMV Location</li>
      <li>Bring the required documents and registration paperwork to your DMV appointment</li>
    </ul>
    <span>
      As a reminder, your TOP will expire on
      &nbsp;
      {replaceText}      
      . Please ensure you go to the DMV as soon as possible after receiving your registration packet.
    </span>
  </>
);
export const registrationText = {
  WITHIN_7DMBG: {
    default: 'Congratulations on your purchase! The Carvana Registration team will begin processing your paperwork after your 7-Day Money Back Guarantee ends. You will receive a text from Carvana once the team begins reviewing your paperwork. To provide you some additional insight into our process, we work with a 3rd party vendor who will also review your paperwork prior to the DMV finalizing your registration. We will continue to send you updates along the way whether it is with Carvana, our partnered vendor, or the DMV!',
    arkansas: 'Congratulations on your purchase! It is important to note that, in Arkansas, we process your registration as Title Only. But do not worry! Carvana will submit the paperwork necessary to transfer ownership of your vehicle\'s title into your name and, once this step has been completed, you will be able to register your vehicle online or in person with your local DMV. The Carvana Registration team will begin reviewing your paperwork after your 7-Day Money Back Guarantee ends. You will receive a text from Carvana once the team begins reviewing your paperwork.',
    selfRegistered:  (
      <>
        <span>
          <strong>Congratulations on your purchase! </strong>
        </span>
        <p>
          It is important to note that you are in a Self Registration State but don’t worry we will still prepare and send you all the paperwork needed! 
        </p>
        <span>
          Here is what your process will look like: 
        </span>
        <ul>
          <li>The Carvana Registration team will begin preparing your paperwork after your 7-Day Money Back Guarantee ends. </li>
          <li>
            You will receive a text from Carvana once the team begins preparing your paperwork and can always review updates here on your dashboard. 
          </li>
          <li>We will review your paperwork and Fedex you a completed packet. This will include a Cover Letter outlining each document and highlighting next steps!</li>
          <li>Once you receive the paperwork from us, you can then walk it into your local DMV office to complete your registration process.</li>
        </ul>
      </>
    ),
    titleOnly: (
      <>
        <span>
          <strong>Congratulations on your purchase!</strong>
        </span>
        <p>
          It is important to note that you are in a &quot;Title Only&quot; state, meaning we will do the heavy lifting of submitting your paperwork to the state to begin the title transfer process.
        </p>
        <span>
          However, you will be responsible for completing your registration via your local DMV or tag agency.
        </span>
        <ul>
          <li>The Carvana Registration team will begin processing your paperwork after your 7-Day Money Back Guarantee ends.</li>
          <li>You will receive a text from Carvana once the team begins reviewing your paperwork.</li>
          <li>
            To provide you some additional insight into our process, we work with a 3rd party vendor who will also review your paperwork prior to the DMV finalizing your title transfer.
          </li>
          <li>We will continue to send you updates along the way whether it is with Carvana, our partnered vendor, or the DMV!</li>
        </ul>
      </>
    )
  },
  READY_TO_WORK: {
    default: 'The Carvana Registration Team is now reviewing your paperwork! Once reviewed and verified, we will then send the paperwork to our partnered 3rd party vendor for an additional review prior to the DMV completing the process. If anything else is required in order for us to complete the review, we will send you a text and email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.',
    arkansas: 'The Carvana Registration Team is now reviewing your paperwork! It is important to note that, in Arkansas, we process your registration as Title Only. That means your state requires the customer to complete the registration process themselves. Don\'t worry though! Just like buying the vehicle, we are going to make the registration process just as easy! Once we have reviewed and verified the paperwork you filled out when you received your vehicle, we will then send the paperwork to the Arkansas Office of Motor Vehicles to complete the transfer of ownership necessary to title your vehicle in your name. Once this step has been completed, you will be able to register your vehicle with your local DMV. If anything else is required in order for us to complete the review, we will send you a text and email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.',
    selfRegistered: (
      <>
        <span>
          <strong>The Carvana Registration Team is now reviewing your paperwork!</strong>
        </span>
        <p>
          It is important to note that you are in a Self Registration State. That means your state requires the customer to complete the registration process themselves.
        </p>
        <span>
          Don&apos;t worry though! Just like buying the vehicle, we are going to make the registration process just as easy!
          Carvana will review the paperwork you filled out when you received your vehicle and once the review is complete.
        </span>
        <ul>
          <li>We will mail you that paperwork so you can then take it to your local DMV to complete the process.</li>
          <li>If anything else is required in order for us to complete the review, we will send you a text and email alert with the details!</li>
        </ul>
        <span>
          You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.
        </span>
      </>
    ),
    titleOnly: (
      <>
        <span>
          <strong>Congratulations on your purchase!</strong>
        </span>
        <p>
          It is important to note that you are in a &quot;Title Only&quot; state, meaning we will do the heavy lifting of submitting your paperwork to the state to begin the title transfer process.
        </p>
        <span>
          Don&apos;t worry though! Just like buying the vehicle, we are going to make completing the registration process just as easy!
          The Carvana Registration Team is now reviewing your paperwork.
        </span>
        <ul>
          <li>Once the titling paperwork is reviewed and verified</li>
          <li>we will then send the paperwork to our partnered 3rd party vendor for an additional review prior to the DMV completing the process.</li>
          <li>If anything else is required in order for us to complete the review, we will send you a text and email alert with the details!</li>
        </ul>
        <span>
          You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.
        </span>
      </>
    )
  },
  DELAYED: {
    default: 'The Carvana Registration Team has found an issue with your registration paperwork and needs your immediate help to resolve it! Please see below what documents need to be updated as well as how you can send us the corrected paperwork. We apologize for the inconvenience and appreciate your help in this matter! Once the updated materials are received, our team will review once more and then proceed with the registration process!',
    arkansas:'The Carvana Registration Team has found an issue with your paperwork and needs your immediate help to resolve it! Please see below what documents need to be updated as well as how you can send us the corrected paperwork. We apologize for the inconvenience and appreciate your help in this matter! Once the updated materials are received, our team will review once more and then proceed with the titling process!'
  },
  SUBMITTED: {
    default: 'The Carvana Registration Team has finished reviewing your paperwork! Your registration packet is now on its way to our partnered vendor for an additional review process. Once the vendor finalizes their review, they will then work with the DMV to complete the process! Please assure that you do not have any outstanding payments with your state DMV as that would potentially cause a delay in the process. If anything else is required in the meantime, we will send you an email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.',
    titleOnly: (
      <>
        <span>
          <strong>The Carvana Registration Team has finished reviewing your paperwork!</strong>
        </span>
        <p>
          Your title documents are now on its way to our partnered vendor for an additional review process.
        </p>
        <span>
          Once the vendor finalizes their review, they will then work with the DMV to complete the title process!
        </span>
        <ul>
          <li>Please assure that you do not have any outstanding payments with your state DMV as that would potentially cause a delay in the process.</li>
          <li>Once completed, you will be required to complete your registration process with the state.</li>
          <li>If anything else is required in the meantime, we will send you an email alert with the details!</li>
        </ul>
        <span>
          You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.
        </span>
      </>
    )
  },
  SUBMITTED_TITLE_ONLY: {
    default: 'The Carvana Registration Team has finished reviewing your paperwork! Your registration packet is now on its way to our partnered vendor for an additional review process. Once the vendor finalizes their review, they will then work with the DMV to complete the process! Please assure that you do not have any outstanding payments with your state DMV as that would potentially cause a delay in the process. If anything else is required in the meantime, we will send you an email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.',
    arkansas: 'The Carvana Registration Team has finished reviewing your paperwork! Your paperwork is now on its way to the AR Office of Motor Vehicles to complete the transfer of ownership on your vehicle. To ensure the most efficient registration experience, please allow the Office of Motor Vehicle a minimum of 7 business days to process your paperwork prior to registering your vehicle online or with your local DMV. If anything else is required in the meantime, we will send you an email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.',
    colorado_vitu: (
      <>
        <p>
          The Carvana Registration team has finished the required Title
          Application paperwork to transfer ownership of your vehicle and has
          sent this to your local county Motor Vehicle Office.
        </p>
        <p>
          Once your county office has completed its process, you will need to
          visit your local motor vehicle office to obtain the updated license
          plate. However, you must wait until Carvana has received confirmation
          that your county has completed the Title transfer paperwork. This
          typically takes 30 business days to finish. Upon completion, you will
          receive a Colorado Title Complete Notice in the mail that will contain
          your registration card. Please make sure to bring this in with you
          once received when you go to pick up your license plate.
        </p>
        <p>
          We will update here once we have received confirmation that your
          county is completed. However, if you would like to check the status
          yourself, you can visit &nbsp;
          <a href="https://mydmv.colorado.gov/_/">
            https://mydmv.colorado.gov/_/
          </a>
          &nbsp; and select “Vehicle Service” then “Check A Title Status” to see
          the status of your Titling process. Please wait a few days for this
          site to update as the county will need to receive the Title
          Application in the mail from Carvana. If you have any additional
          questions, please contact your county office once your title has been
          processed.
        </p>
      </>
    ),    
    nevada_instate: (
      <>
        <p>
          The Carvana Registration team has completed the required Title Application
          paperwork to transfer ownership of your vehicle and has sent this to your
          local DMV office.
        </p>
        <p>
          A copy of your Electronic Dealers Report of Sale (EDRS) has been uploaded
          to your Carvana portal and also emailed to the email address on file.
          Once you receive the copy of the EDRS you are eligible to complete the
          registration process for your vehicle. If you provided a NV drivers license at the time of sale,
          you may be eligible to complete the registration for your vehicle online.
          You may be required to provide a copy of the EDRS, a copy of the completed emissions inspection,
          and/or proof of insurance to the MVD directly upon registering your vehicle.
        </p>
        <p>
          For more information about what is required at the time of registration, 
          you can visit the NV DMV website at
          &nbsp;
          <a href="https://dmv.nv.gov/regdealer.htm">
            https://dmv.nv.gov/regdealer.htm
          </a>
          &nbsp;. 
          If you have any additional questions, please contact your DMV office directly.
        </p>
      </>
    ),    
    nevada_outofstate: (
      <>
        <p>
          The Carvana Registration team has completed the required Title Application 
          paperwork to transfer ownership of your vehicle and will be sending it to your local DMV office. 
        </p>
        <p>
          If you have not done so already, you will be required to visit your local DMV office 
          to complete the registration process for your new vehicle. 
          If you are visiting a DMV office in Carson City, Henderson, Las Vegas or Reno please note 
          that as of 8/15/22, these locations no longer accept walk-ins and require an appointment be set. 
          This can be done online via 
          &nbsp;
          <a href="https://dmv.nv.gov/appointments.htm|https://dmv.nv.gov/appointments.htm">
            https://dmv.nv.gov/appointments.htm|https://dmv.nv.gov/appointments.htm
          </a>
          &nbsp;.
        </p>
        <p>
          If you already completed the registration process for your vehicle, 
          you can disregard this message.
        </p>
        <p>
          You may be required to provide a copy of your completed emissions, VIN inspection, tax letter*, 
          and/or proof of insurance to the DMV directly.
        </p>
        <p>
          For more information on what is required at the time of registration, you 
          can visit the NV DMV website at
          &nbsp;
          <a href="https://dmv.nv.gov/regoutofstate.htm">
            https://dmv.nv.gov/regoutofstate.htm
          </a>
          &nbsp;.
          If you have any additional questions specific to your registration process, 
          please contact your DMV office directly.
        </p>
        <p>
          *Taxes are collected at the time of sale and remitted on your behalf. 
          You should have been provided a tax statement at delivery to provide to 
          the DMV so taxes are not collected again at the time of registration. 
          If you did not receive this letter or have any questions, please contact 
          Carvana directly at (800).333.4554.
        </p>
      </>
    )
  },
  REJECTED: {
    default: 'Alert! Our 3rd Party Vendor and DMV has run into a snag with your registration and needs your immediate help resolving this issue! Please see below what is outstanding and the method in which you should send the corrected paperwork back to us. We apologize for the inconvenience and appreciate your help in getting this resolved! Once Carvana receives the corrected paperwork back, we will forward along to our partnered vendor so that they can finalize your registration with the DMV.',
    arkansas: 'Alert! The AR Office of Motor Vehicles has run into a snag with the titling of your vehicle and needs your immediate help resolving this issue! Please see below what is outstanding and the method in which you should send the corrected paperwork back to us. We apologize for the inconvenience and appreciate your help in getting this resolved! Once Carvana receives the corrected paperwork back, we will forward along to the AR Office of Motor Vehicles so they can complete the transfer of ownership of your vehicle.'
  },
  COMPLETED: {
    default: 'Your registration is completed! Your plates and tags are being sent to the address you listed on your Carvana account. Thank you for your patience and we hope you are enjoying your Carvana vehicle!',
    selfRegistered: (
      <>
        <span>
          <strong>The Carvana Registration Team has completed reviewing your paperwork!</strong>
        </span>
        <p>
          As mentioned previously, you are in a Self Registration state which requires the customer to finish the registration process.
        </p>
        <span>
          Our review has verified that all the paperwork is accurate and will be sufficient for your DMV to use to finish up your registration process.
        </span>
        <ul>
          <li>Keep an eye out as we have sent the complete packet to your address!</li>
          <li>Once received, you can then take that to your local DMV to receive your registration.</li>
        </ul>
      </>
    ),
    hasTransferTag: 'Your registration is completed! Per your request, we have transferred your registration from an old vehicle to your new Carvana vehicle! The registration is on its way to you in the mail. Once received, you can then place your old plates onto your new car.',
    fedExNoTransfer: 'Your registration is completed! Your plates and tags are being sent to you via FedEx and the tracking number is {trackingNumber}. Since this is a highly important package, FedEx will require a signature at delivery in order to release the package.',
    trackingNoTransfer: 'Your registration is completed! Your plates and tags are being sent to you via {courierName} and the tracking number is {trackingNumber}. Since this is a highly important package, {courierName} may require a signature at delivery in order to release the package.',
    georgia: 'Your Carvana registration has been completed and your new plates are on the way! In Georgia, plates are typically sent via USPS and arrive within 15 days from completion.',
    colorado_vitu: (
      <>
        <span>
          Great news! Your local county Motor Vehicle Office has completed your
          Title transfer process! You may now visit your local office to
          complete your registration and receive your plates. Please visit your
          local office to receive your plates and tags. When you go, please be
          sure to bring the following items:
        </span>
        <ul>
          <li>The Colorado Title Complete Notice you received in the mail</li>
          <li>
            Proof of Insurance for the vehicle issued in the state of Colorado
          </li>
          <li>Proof of Emissions (if required for your vehicle/county)</li>
          <li>Payment for the Registration Fees</li>
        </ul>
      </>
    ),
    titleOnly: (
      <>
        <span>
          <strong>Your Titling Paperwork has been processed by our vendor/the DMV!</strong>
        </span>
        <p>
          As mentioned previously, you are in a &quot;Title Only&quot; state which requires the customer to finish the registration process.
        </p>
        <span>
          Our review has verified that all the paperwork is accurate and will be sufficient for your DMV to use to finish up your registration process.
        </span>
        <ul>
          <li>You will need to travel to your associated DMV or tag agency to complete this process and receive your tags/permanent plate.</li>
          <li>Please refer to the FAQ provided at delivery for a list of documents that you will need to bring with you to the DMV to complete registration.</li>
        </ul>
        <span>This usually includes but is not limited to your Driver&apos;s License, Insurance Card/Binder/Declaration Page, and Retail Purchase Agreement (RPA).</span>
      </>
    ),
    earlyRegistration: (
      <>
        <span>
          <strong>Your registration is completed!</strong>
        </span>
        <p>
          Your plates and tags should have been provided with the vehicle upon purchase.
        </p>
        <span>
          Your title will be processed in accordance with current DMV processing times and should be shipped out to you or your lienholder (where applicable) when completed.
          Please refer to your state DMV website for further guidance on current processing times.
        </span>
      </>
    )
  },
  PARTIAL_REJECTED_RESOLVED: {
    default: 'Our Team has verified that the documents you provided are sufficient to proceed with your Registration. We appreciate your assistance in getting that resolved! If anything else is required in order for us to complete the review, we will send you a text and email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.',
    arkansas: 'Our Team has verified that the documents you provided are sufficient to proceed with the titling of your vehicle. We appreciate your assistance in getting that resolved! If anything else is required in order for us to complete the review, we will send you a text and email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.'
  },
  PARTIAL_REJECTED_RECEIVED: {
    default: 'The Carvana Registration Team has received the outstanding documents that we previously requested. We will review those documents and verify that they are now sufficient to proceed with the Registration process. If anything else is required in order for us to complete the review, we will send you a text and email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.',
    arkansas: 'The Carvana Registration Team has received the outstanding documents that we previously requested. We will review those documents and verify that they are now sufficient to proceed with the titling process. If anything else is required in order for us to complete the review, we will send you a text and email alert with the details! You can also continue to check back here, on your Post Sale Dashboard, for status updates as well.'
  },
  UNTRACKED_STATUS: {
    default: 'Congratulations on your purchase! The Carvana Registration team will begin processing your paperwork after your 7-Day Money Back Guarantee ends. You will receive a text from Carvana once the team begins reviewing your paperwork.\nMost states will take about 30 days to issue your new plates. We will reach out if we hit a snag with the DMV and need to collect additional documents.',
    selfRegistered: (
      <>
        <span>
          <strong>Congratulations on your purchase!</strong>
        </span>
        <p>
          The Carvana Registration team will begin processing your paperwork after your 7-Day Money Back Guarantee ends.
        </p>
        <ul>
          <li>You will receive a text from Carvana once the team begins reviewing your paperwork.</li>
        </ul>
        <span>
          It is important to note that you are in a Self Registration State but do not worry we will still prepare and send you all the paperwork needed!
        </span>
      </>
    ),
  },
  PENDING_EXCHANGE: {
    default: (
      <span>
        Our records indicate that you are currently in the process of exchanging your vehicle. 
        Your registration is currently &apos;paused&apos;, and will not proceed unless the exchange is cancelled.
      </span>
    )
  }
};

export const dmvWarningText = {
  'XX': 'XX is allowing each county to determine a grace period on temp plate expirations.'
}

export default {
  registrationText,
  dmvWarningText
};
